// @ts-check
import React from "react"
import CustomDialog from "../../../../components/molecules/CustomDialog.molecule"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import SecondaryButton from "../../../../components/molecules/buttons/SecondaryButton.molecule"
import useTimeRegisterContext from "../../hooks/useTimeRegisterContext.hook"
import { Info } from "luxon"
import {getDateTime, isSameDay} from "../../../../utils/dateTime.utils"
const { createIgnoredWorkDay } = require("../../../../services/workDay.service")
const { useSession } = require("../../../../hooks/auth/useSession.hook")

const MissingDayDialog = () => {
  const {
    showMissingDayDialog,
    setShowMissingDayDialog,
    setShowedMissingDayDialog,
    selectedDate,
    setSelectedDate,
    setEditingMissingDay,
    setIsDayEditable,
    setRefresh,
    daysOff,
  } = useTimeRegisterContext()
  const { user } = useSession()
  return (
    <CustomDialog
      key={selectedDate.toString()}
      visible={showMissingDayDialog}
      setVisible={setShowMissingDayDialog}
      headerTitle="Día sin registrar"
      headerIconClass="pi pi-exclamation-triangle clr-danger"
      withoutDivider
      footer={
        <div className="flex justify-content-end">
          <SecondaryButton
            label="Registrar tareas"
            onClick={() => {
              setShowMissingDayDialog(false)
              setShowedMissingDayDialog(true)
              setEditingMissingDay(true)
              setIsDayEditable(true)
            }}
            className="clr-secondary"
          />
          <PrimaryButton
            label="Ignorar día"
            icon="pi pi-check"
            className="m-0"
            onClick={async () => {
              await createIgnoredWorkDay(
                user.id,
                getDateTime(selectedDate).toISODate()
              )
              setRefresh()
              setShowMissingDayDialog(false)
              setShowedMissingDayDialog(false)
              setEditingMissingDay(false)

              const currentDate = getDateTime(selectedDate)
              let nextDate = currentDate.plus({ days: 1 }).toJSDate()
              const todayDate = getDateTime().toJSDate()

              while (
                daysOff.includes(nextDate.toISOString().split("T")[0]) && // Skip vacation days
                !isSameDay(nextDate, todayDate) // Until today
              ) {
                nextDate = getDateTime(nextDate)
                  .plus({ days: 1 })
                  .toJSDate()
              }
              setSelectedDate(nextDate)
            }}
            borderAccent
            rounded
          />
        </div>
      }
    >
      ¡Ups! Tienes el día{" "}
      {Info.weekdays("long")[getDateTime(selectedDate).weekday - 1]} en
      la semana actual sin registrar. ¿Qué te gustaría hacer?
    </CustomDialog>
  )
}

export default MissingDayDialog
